import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import {ROUTE_PATHS} from '@di-shared/routes';
import {useNavigate} from 'react-router';
import ImageSelector from '@di-shared/features/common/ImageSelector';

export interface SafeDrivingResetKrProps {
  vin: string;
}

function SafeDrivingResetKr({vin}: SafeDrivingResetKrProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();

  async function openScoreResetBottomSheet() {
    const result = await ccWebviewUtils.openBottomSheetWebViewUrl<boolean>(
      ROUTE_PATHS.BOTTOM_SHEET_SAFE_DRIVING_RESET_RECHECK.getFullPath(),
      {
        vin,
      }
    );
    if (result) {
      navigate(ROUTE_PATHS.HOME.getFullPath(vin));
    }
  }

  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T20169')}</h1>
      </Header>

      <main className="content page_safe_driving">
        <section className="section">
          <div className="section_heading type_main">
            <h2 className="section_heading_title">{t('T20170')}</h2>
            <p className="section_heading_desc">{t('T20171')}</p>
          </div>
          <div className="section_visual visual_score_reset">
            <ImageSelector
              className="section_visual_img"
              alt="section_visual_img"
              kiaLightSrc={() => import('@di-shared/assets/img/visual/safe_driving_score_reset_light.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/visual/safe_driving_score_reset.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/visual/hyundai/safe_driving_score_reset_light.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/visual/hyundai/safe_driving_score_reset.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/visual/genesis/safe_driving_score_reset_light.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/visual/genesis/safe_driving_score_reset.png')}
            />
          </div>
        </section>
      </main>
      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_outline btn_full btn_data_reset"
          onClick={() => openScoreResetBottomSheet()}
        >
          {t('T20172')}
        </button>
      </div>
    </div>
  );
}

export default SafeDrivingResetKr;
